import React from 'react';
import './App.sass';
import '../public/local_post_office-24px.svg'
// Component Imports 
import Nav from './components/Nav'
import LeftContnet from './components/LeftContent'
import CenterContent from './components/CenterContent'
import RightContent from './components/RightContent'
// Particles 
import Particles from 'react-particles-js';

class App extends React.Component {
  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
  }
  render() {

    return (
      <>
    {/* ==== Nav Bar ==== */}
    <div className="Main">
      <Nav/>
      <Particles className="particle"/>
      {/* ==== Main Content ==== */}
      <div className="Content">
        <LeftContnet/>
        {/* ==== CENTER CONTENT ==== */}
        <CenterContent/>
        {/* ==== RIGHT PANEL CONTAINS LINKS TO GIT, LINK, EMAIL ==== */}
        <RightContent/>
      </div>
     </div>
    </>
  );
}
}

export default App;
